import { faCaretDown, faCaretRight } from '@fortawesome/pro-solid-svg-icons';
import { numeralFormatter, numeralFormatterCurrency } from 'ns_libs/formatter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';

export interface IExpandableRowProps {
    partnerType: string;
    data: any
}

const ExpandableRow = ({ partnerType, data } : IExpandableRowProps) => {
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <>
            <tr
                key={`partner-returns-row-for-${partnerType}`}
                className="NSTable__tbody__tr text-end"
                onClick={() => setIsExpanded(!isExpanded)}
                role="button"
            >
                <td
                    className="text-white"
                    key={`partner-returns-label-${partnerType}`}
                >
                    <div className="d-flex align-items-center">
                        {data.byDeal.length && <FontAwesomeIcon icon={isExpanded ? faCaretDown : faCaretRight} className="mr-2" />}
                        <span>{partnerType}</span>
                    </div>
                </td>
                <td
                    className="text-white"
                    key={`partner-contributions-for-${partnerType}-totals`}
                >
                    {numeralFormatterCurrency(data.totals.contributions, '$0,0')}
                </td>
                <td
                    className="text-white"
                    key={`partner-net-profit-for-${partnerType}-totals`}
                >
                    {numeralFormatterCurrency(data.totals.netProfit, '$0,0')}
                </td>
                <td
                    className="text-white"
                    key={`partner-roi-for-${partnerType}-totals`}
                >
                    {`${numeralFormatter(Math.abs(data.totals.roi) * 100, '0,0.00')}%`}
                </td>
                <td
                    className="text-white"
                    key={`partner-emx-for-${partnerType}-totals`}
                >
                    {`${numeralFormatter(Math.abs(data.totals.emx), '0,0.00')}x`}
                </td>
                <td
                    className="text-white"
                    key={`partner-irr-for-${partnerType}-totals`}
                >
                    {`${numeralFormatter(Math.abs(data.totals.irr) * 100, '0,0.00')}%`}
                </td>
            </tr>
            {isExpanded && data.byDeal?.map((dealReturns: any) => (
                <tr
                    key={`partner-${dealReturns.partnerName}-returns-deal-row-for-${dealReturns.dealName}`}
                    className="NSTable__tbody__tr text-end NSTable__tbody__tr--level-2"
                >
                    <td
                        className="text-white"
                        key={`partner-returns-${dealReturns.partnerName}-deal-label-${dealReturns.dealName}`}
                    >
                        <div className="d-flex flex-column ml-3">
                            <span className="text-muted">{dealReturns.partnerName}</span>
                            <span className="text-white">{dealReturns.dealName}</span>
                        </div>
                    </td>
                    <td
                        className="text-white align-middle"
                        key={`partner-${dealReturns.partnerName}-contributions-for-${dealReturns.dealName}`}
                    >
                        {numeralFormatterCurrency(dealReturns.contributions, '$0,0')}
                    </td>
                    <td
                        className="text-white align-middle"
                        key={`partner-${dealReturns.partnerName}-net-profit-for-${dealReturns.dealName}`}
                    >
                        {numeralFormatterCurrency(dealReturns.netProfit, '$0,0')}
                    </td>
                    <td
                        className="text-white align-middle"
                        key={`partner-${dealReturns.partnerName}-roi-for-${dealReturns.dealName}`}
                    >
                        {`${numeralFormatter(Math.abs(dealReturns.roi) * 100, '0,0.00')}%`}
                    </td>
                    <td
                        className="text-white align-middle"
                        key={`partner-${dealReturns.partnerName}-emx-for-${dealReturns.dealName}`}
                    >
                        {`${numeralFormatter(Math.abs(dealReturns.emx), '0,0.00')}x`}
                    </td>
                    <td
                        className="text-white align-middle"
                        key={`partner-${dealReturns.partnerName}-irr-for-${dealReturns.dealName}`}
                    >
                        {`${numeralFormatter(Math.abs(dealReturns.irr) * 100, '0,0.00')}%`}
                    </td>
                </tr>
            ))}
        </>
    );
};

export default ExpandableRow;
